import axios from '../utils/axios'
import { getStaticConfigs } from "../helpers/common";

export async function getSideMenu()
{
      const staticConfigs = await getStaticConfigs();

      return axios.get(
            `${staticConfigs?.REACT_APP_API_BASE_URL}/gh/configs/eom/side-bar`
      );
}

export async function getSideBottomMenu()
{
      const staticConfigs = await getStaticConfigs();

      return axios.get(
            `${staticConfigs?.REACT_APP_API_BASE_URL}/gh/configs/eom/side-bottom`
      );
}

